/* eslint-disable @angular-eslint/directive-selector */

import { Directive, inject } from '@angular/core';
import { ButtonComponent } from '../components/basic/button/button.component';

@Directive({ selector: 'app-button[submit]' })
export class ButtonSubmitDirective {
  private button = inject(ButtonComponent);

  constructor() {
    this.button.submit.set(true);
  }
}
